import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../common-http.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { HttpClient, HttpContext, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IBiddingRequest } from '../../models/IBiddingRequest';
import { IBiddingResponse } from '../../models/IBiddingResponse';
import { CRITICAL_ERROR } from '../../core/interceptors/errors/critical-error.token';


@Injectable({
  providedIn: 'root'
})
export class BidService {

  private httpService = inject(CommonHttpService)
  bidResponseSignal = signal<IBiddingResponse | null>(null);
  errorSignal = signal<string>('');

  errorMessage: string | null = null;

  constructor(private oidcSecurityService: OidcSecurityService, private http: HttpClient) { }

  postBidding(itemId: number, biddingData: IBiddingRequest): Observable<string> {

    const url = `${environment.apiUrl}/v3/items/${itemId}/bid`;

    // console.log(url);

    const body =
      `selectedCard=${encodeURIComponent(biddingData.selectedCard)}` +
      `&bidType=${encodeURIComponent(biddingData.bidType)}` +
      `&amount=${encodeURIComponent(biddingData.amount)}` +
      `&coverTheFee=${encodeURIComponent(biddingData.coverTheFee)}` +
      `&isFromBidderCommunity=${encodeURIComponent(biddingData.isFromBidderCommunity)}`;

    // console.log(body);
    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {

        let headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Accept', 'application/json')
          .set('Authorization', `Bearer ${authResult.accessToken}`);

        return this.http.post<string>(url, body, {
          headers,
          responseType: 'text' as 'json',
          context: new HttpContext().set(CRITICAL_ERROR, true)
        });
      }),
      tap(response => {
        // console.log('status received:', response);
        this.bidResponseSignal.set({ status: response });
      }),
      catchError((error: HttpErrorResponse) => {

        return throwError(() => error);
      })
    );
  }
}